module.exports = __webpack_public_path__ + "static/img/blueTee1.3cce4508.jpg";